import focusedImg from '../assets/images/focused.avif';

export default function AboutContent({ setActiveTab }) {
  return (
    <div className="flex flex-col md:flex-row items-center mb-16">
      <div className="md:w-1/2 mb-10 md:mb-0">
        <h1 className="text-4xl font-bold text-gray-800 mb-6">About DevsKe</h1>
        <p className="text-xl text-gray-600 mb-6">
          We are a leading global technology solutions provider, with a mission to empower businesses through innovative software solutions.
        </p>
        <p className="text-gray-700 mb-6">
          Founded in 2021, DevsKe has grown from a small team of developers into a full-service technology company. With expertise spanning across various industries, we proudly serve clients across the world, combining local market insights with global technical capabilities to deliver impactful, world-class solutions.
        </p>
        <button 
          onClick={() => setActiveTab('contact')} 
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-md font-medium transition duration-300"
        >
          Contact Our Team
        </button>
      </div>
      <div className="md:w-1/2 flex justify-center">
        <img 
          src={focusedImg} 
          alt="DevsKe team" 
          className="rounded-lg shadow-xl w-full max-w-md"
        />
      </div>
    </div>
  );
}

// devs
